/**
 * Redirects to the AWS Builder ID SHIM logout endpoint
 * @param shimUrl Base URL for the SHIM logout API
 * @param clientId Client ID for the OIDC application
 */
export function builderIdShimLogout(shimUrl: string, clientId: string): void {
  const redirectUri = `${window.location.protocol}//${
    window.location.host
  }/logout?client_id=${encodeURIComponent(clientId)}`;
  const logoutPath = `${shimUrl}/oidc/logout?client_id=${encodeURIComponent(
    clientId
  )}&redirect_uri=${encodeURIComponent(redirectUri)}`;
  window.location.href = logoutPath;
}

export default builderIdShimLogout;
